import { Info } from "lucide-react";

interface Props {
  count: number;
}

// O ALCANCE da mudança, em uma frase, acima do botão de salvar.
// É CONTAGEM, não projeção. A spec proíbe calcular ou exibir o deslocamento que a mudança causará
// nos indicadores: prometer "o OEE da Debulhagem vai cair 4 pp" exigiria recalcular o histórico
// inteiro contra um calendário hipotético, e o número sairia errado sempre que a janela consultada
// na tela não fosse a mesma da projeção. Um número errado sobre indicador é pior que nenhum.
// O caso ZERO é o que mais precisa da frase, não o que menos: numa fábrica onde toda linha declarou
// expediente próprio, salvar o padrão não muda indicador nenhum — e sem dizer isso, o gestor
// cadastra a semana inteira esperando um efeito que não vem.
export function AffectedLinesNotice({ count }: Props) {
  return (
    <p
      className="flex items-start gap-1.5 rounded-md bg-bg-muted-rd px-3 py-2 text-[12px] text-text-secondary"
      role="status"
    >
      <Info className="mt-0.5 h-3.5 w-3.5 shrink-0 text-text-tertiary" aria-hidden />
      {count === 0 ? (
        <span>
          Nenhuma linha segue o padrão da fábrica no momento — todas declaram expediente próprio.
          Este cadastro passa a valer para as linhas que voltarem a seguir o padrão.
        </span>
      ) : (
        <span>
          Isto vale para <strong className="font-medium text-text-primary">{count}</strong>{" "}
          {count === 1 ? "linha que segue" : "linhas que seguem"} o padrão da fábrica.
        </span>
      )}
    </p>
  );
}
